<template>
  <div>
    <div class="app-header">
      <div class="bread-crumb">
        <ul class="list-item-container">
          <li v-for="(item, index) in arrayStep" class="list-item" :key="item">
            <a href="javascript:void(0)"
               class="step-name-breadcrumb body-text scheduler-text-custom-color"
               :style="{'font-weight': item === 'Select services'  ? 'bold' : 'normal'}">
              {{item}}
            </a>
            <div class="arrow-icon" v-if="index != arrayStep.length - 1" role="navigation"></div>
          </li>
        </ul>
      </div>
    </div>

    <div class="my-information-container">
      <h1 class="h1-text step-name" tabindex="0" ref="focusTab">Select Services</h1>
      <div class="body-text margin-top-10px">Welcome to the ADURO WellMetrics scheduling tool. Before you begin to schedule, we need to know some information about you. Your selections will determine which events are available for you. You can edit this information later.</div>
      <div v-if="hasFluShot" class="my-info-card common-card margin-top-24px scheduler-card-responsive">
        <div class="card-header-container">
          <h2 class="h5-text" aria-label="Event Information please select at least one of the follwoing options to continue" role="Heading" tabindex="0">Event Information</h2>
          <div class="body-text card-sub-title">Select all that apply, please select at least one option.<span class="require-field-icon" style="color: red; padding-left: 5px">*</span></div>
        </div>
        <div class="check-box-responsive margin-top-24px">
          <div class="checkbox-container">
            <b-checkbox
              id="checkbox-1"
              v-model="screenBoxStatus"
              class="ap-checkbox-group body-text scheduler-checkbox-group-custom"
              :style="{'font-weight': screenBoxStatus  ? 'bold' : 'normal'}"
            >
              I want to get a biometric screening
            </b-checkbox>
          </div>
        </div>
        <div class="check-box-responsive margin-top-16px">
          <div class="checkbox-container">
            <b-form-checkbox
              id="checkbox-2"
              v-model="fluBoxStatus"
              class="ap-checkbox-group body-text scheduler-checkbox-group-custom"
              :style="{'font-weight': fluBoxStatus  ? 'bold' : 'normal'}"
            >
              I want to get a flu shot
            </b-form-checkbox>
          </div>
        </div>
      </div>

      <div v-if="hasSpousal" class="my-info-card common-card margin-top-24px scheduler-card-responsive">
        <div class="card-header-container">
          <h2 class="h5-text" tabindex="0">{{ spouseLabel }} Information</h2>
        </div>
        <div class="body-text margin-top-10px">
          If you have a {{ spouseLabel }}, you can also schedule appointments for them. If your {{ spouseLabel }} is also an employee at your company, please have them schedule their own appointment or come with you as a walk-in appointment (additional wait time may apply).
        </div>
        <div class="check-box-responsive margin-top-24px">
          <div class="checkbox-container">
            <b-form-checkbox
              id="checkbox-3"
              v-model="spousalBoxStatus"
              class="ap-checkbox-group body-text scheduler-checkbox-group-custom"
              :style="{'font-weight': spousalBoxStatus === 'accepted' ? 'bold' : 'normal'}"
            >
              I will be bringing my {{ spouseLabel }} to this event
            </b-form-checkbox>
          </div>
        </div>
        <div v-if="spousalBoxStatus" class="set-height-including-calendar">
          <div class="text-box-responsive">

            <div class="row name-input-wrapper">

              <div class="col-xs-12 col-md-6">
                <div class="field-display-wrapper margin-top-16px">
                  <div class="field-wrapper">
                    <div id="firstNameElement">
                      <label
                        for="inputFirstName"
                        class="ap-checkbox-group scheduler-checkbox-group-custom margin-top-16px">
                        First Name
                      </label>
                      <input
                        id="inputFirstName"
                        ref="firstName"
                        role="textbox"
                        type="text"
                        name="firstName"
                        class="input"
                        placeholder="First name"
                        disabled
                      />

                    </div>

                    <div class="require-field-icon" aria-label="* field denotes as Mandatory fields.">*</div>
                  </div>
                  <div id="firstNameError" :class="{'noDisplay': spousalBoxStatus === 'not_accepted'}" class="error-display">
                    <div v-if="errors.has('firstName')" class="alert-icon-red-error" aria-label="Error icon"></div>
                    <div class="error-text-color">{{ errors.first('firstName') }}</div>
                  </div>
                </div>
              </div>

              <div class="col-xs-12 col-md-6">
                <div class="field-display-wrapper margin-top-16px">
                  <div class="field-wrapper">
                    <div id="lastNameElement">

                      <label for="inputLastName" class="ap-checkbox-group scheduler-checkbox-group-custom margin-top-16px">Last Name</label>
                      <input
                        id="inputLastName"
                        ref="lastName"
                        role="textbox"
                        type="text"
                        name="lastName"
                        class="input"
                        placeholder="Last name"
                        disabled
                      />

                    </div>
                    <div class="require-field-icon" aria-label="* field denotes as Mandatory fields.">*</div>
                  </div>
                  <div id="lastNameError" :class="{'noDisplay': spousalBoxStatus === 'not_accepted'}" class="error-display">
                    <div v-if="errors.has('lastName')" class="alert-icon-red-error" aria-label="Error icon"></div>
                    <div class="error-text-color">{{ errors.first('lastName') }}</div>
                  </div>
                </div>
              </div>

            </div>

            <div class="row">
              <div class="col-md-6 col-xs-12">
                <div class="email-input-wrapper field-display-wrapper">
                  <div class="field-wrapper">
                    <div id="emailElement">

                      <label
                        for="inputSpouseEmail"
                        class="ap-checkbox-group scheduler-checkbox-group-custom margin-top-16px">
                        Email
                      </label>

                      <input
                        id="inputSpouseEmail"
                        ref="email"
                        role="textbox"
                        type="email"
                        name="email"
                        class="input"
                        placeholder="Email"
                        disabled
                      />
                    </div>
                    <div class="require-field-icon" aria-label="* field denotes as Mandatory fields.">*</div>
                  </div>
                </div>
              </div>

              <div class="col-md-6 col-xs-12">
                <div class="row">
                  <div class="col-md-6 col-xs-6">
                    <div class="birthday-input-wrapper field-display-wrapper">
                      <div class="field-wrapper">
                        <div id="dobElement" ref="dob1">

                          <label
                            aria-label="Enter Spouce Birth Date using format MM/DD/YYYY"
                            class="ap-checkbox-group scheduler-checkbox-group-custom margin-top-16px"
                            style="min-width: 228px" >
                            Spouse Birth Date
                          </label>

                          <input
                            id="picker-component-container"
                            ref="dob"
                            role="textbox"
                            name="dob"
                            class="input"
                            placeholder="Birth date"
                            disabled
                          />

                        </div>
                        <div class="require-field-icon" aria-label="* field denotes as Mandatory fields.">*</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="select-button-container margin-top-24px">
        <button class="select-button ap-btn scheduler-button-custom-color button-text-white" aria-label="Select location" role="button">
          SELECT LOCATION
        </button>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'schedulerPreviewMyInfoPage',
    components: {},
    props: {
      hasFluShot: {
        type: Number,
        default: 0
      },
      hasSpousal: {
        type: Boolean,
        default: false
      },
      spouseLabel: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        screenBoxStatus: false,
        fluBoxStatus: false,
        spousalBoxStatus: false,
        arrayStep: ['Select services', 'Select location', 'Select event', 'Select time', 'Review and Confirm']
      }
    },
    methods: {
    }
  }
</script>

<style lang="less" scoped>
  .app-header{
    background-color: white;
    box-shadow: 0 0 1px 0 rgba(0,0,0,0.2), 0 2px 1px 1px rgba(0,0,0,0.1);
    margin-top: 24px;
    height: auto;
    padding: 24px 48px;
    width: 100%;
    overflow: auto;
  }

  .bread-crumb{
    padding: 8px 0 8px 48px;
    width: 810px;
    margin: auto;

    .list-item-container{
      padding: 0;
      margin: 0;
      display: flex;

      .list-item{
        display: flex;
        margin-right: 16px;
        opacity: 1;
        white-space: nowrap;

        .step-name-breadcrumb{
          &:hover{
            cursor: pointer;
          }
        }
        .arrow-icon{
          margin-left: 8px;
          align-self: center;
          width: 16px;
          height: 16px;
          background: url('../../../../static/img/forward-line.svg') no-repeat center;
        }

        &.pass{
          opacity: 1;
          font-weight: bold;
          .step-name-breadcrumb{
            color: red;
          }
        }

        &.current{
          opacity: 1;
          font-weight: bold;
        }
      }
    }
  }

  .my-information-container {
    padding: 24px 40px 48px 40px;
    width: 810px;
    margin: auto;

    .my-info-card {
      margin-top: 24px;
      padding: 24px;

      .field-wrapper {
        display: flex;
        align-items: center;

        .require-field-icon {
          color: red;
          padding-left: 5px;
        }
      }

      .card-header-container{
        display: flex;
        flex-direction: row;

        .body-text {
          line-height: 28px;
        }

        .card-sub-title{
          margin-left: 16px;
        }

        @include media-breakpoint-down(sm){
          flex-direction: column;

          .card-sub-title{
            margin-left: 0;
          }
        }
      }
    }

    .check-box-responsive {
      display: flex;
      flex-direction: row;

      .body-text {
        line-height: 24px;
      }
    }
    .text-box-responsive {
      .name-input-wrapper {
        justify-content: space-between;
        input {
          min-height: 48px;
          border-radius: 4px;
          border: 1px solid #B9B9B9;
          padding: 12px 16px;
        }
        @include media-breakpoint-down(xs){
          flex-direction: column;
        }
      }

      .email-input-wrapper {
        display: flex;
        flex-direction: column;
        input {
          height: 48px;
          border: 1px solid #B9B9B9;
          border-radius: 4px;
          padding: 12px 16px;
        }
      }

      .birthday-input-wrapper{
        position: relative;

        input {
          height: 48px;
          width: 100%;
          padding: 8px;
          color: black;
          border: 1px solid #B9B9B9;
          border-radius: 4px;
        }
      }

      .employee-input-wrapper{
        .employee-id-input{
          position: relative;

          .character-s{
            top: 30px;
            right: 16px;
            position: absolute;
          }
        }
      }
    }

    .select-button-container {
      display: flex;
      justify-content: flex-end;
      margin-right: -24px;

      .select-button {
        padding: 12px 32px;
        border-radius: 4px;
        background-color: #9D001D;
        width: fit-content;
      }

      .accessibility-container {
        display: flex;
        float: right;
        flex-wrap: wrap;
      }

      .select-button-detail {
        display: flex;
        justify-content: flex-end;
        margin-top: 24px;
      }
      @include media-breakpoint-down(xs){
        margin-right: 0;
      }
    }

    .field-display-wrapper {
      .ap-checkbox-group{
        line-height: 8px !important;
        .custom-control-input {

        }
      }

      .input{
        width: 100%;
        height: 48px;
        border: 1px solid black;
        border-radius: 4px;
        padding: 12px 16px;
      }
    }

    .checkbox-container {
      .custom-checkbox {
        :nth-child(2) {
          padding-top: 3px;
          padding-left: 10px;
          &::before, &::after {
            height: 24px;
            width: 24px;
            border-radius: unset;
          }
        }
      }
    }
  }

  .h5-text {
    color: #424242;
    font-size: 20px;
    font-weight: 700;
    letter-spacing: .17px;
    line-height: 28px;
    text-transform: capitalize;
  }

</style>



// WEBPACK FOOTER //
// SchedulerPreviewMyInfoPage.vue?b22f96cc